<template>
    <div class="container mt-3">
        <h3>{{ $t('onCall.title') }}</h3>
        <div v-if="loading" class="text-center mt-3">
            <div class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">{{ $t('common.loading') }}</span>
            </div>
        </div>
        <div v-else-if="onCallList.length > 0">
            <!-- Six columns cannot fit a phone. Below md the same rows are
                 stacked so the name and phone stay large and tappable — calling
                 the on-call person is what this screen is for. -->
            <ul class="list-group mt-3 d-md-none">
                <li v-for="item in onCallList" :key="item.id" class="list-group-item"
                    :class="{ 'list-group-item-danger': isWeekend(item.date) }">
                    <div class="d-flex justify-content-between small text-body-secondary">
                        <span>{{ formatDisplayDate(item.date) }}</span>
                        <span>{{ item.period }}</span>
                    </div>
                    <div class="fw-bold">{{ item.name }}</div>
                    <a class="text-danger" :href="`tel:${item.phone}`">{{ item.phone }}</a>
                    <div class="small text-body-secondary">
                        {{ item.profile_group_name }}<span v-if="item.region_name"> &middot;
                            {{ item.region_name }}</span>
                    </div>
                </li>
            </ul>

            <div class="table-responsive d-none d-md-block">
                <table class="table table-sm table-bordered mt-3">
                    <thead>
                        <tr>
                            <th>{{ $t('onCall.date') }}</th>
                            <th>{{ $t('onCall.name') }}</th>
                            <th>{{ $t('onCall.phone') }}</th>
                            <th>{{ $t('onCall.period') }}</th>
                            <th>{{ $t('onCall.group') }}</th>
                            <th>{{ $t('onCall.region') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in onCallList" :key="item.id" :class="{ 'table-danger': isWeekend(item.date) }">
                            <td>{{ formatDisplayDate(item.date) }}</td>
                            <td>{{ item.name }}</td>
                            <td><a class="text-danger" :href="`tel:${item.phone}`">{{ item.phone }}</a></td>
                            <td>{{ item.period }}</td>
                            <td>{{ item.profile_group_name }}</td>
                            <td>{{ item.region_name }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-else>
            <p class="text-body-secondary mt-3">{{ $t('onCall.notFound') }}</p>
        </div>
    </div>
</template>

<script>
import axios from '@/services/axios';
import { useDate } from '@/composables/useDate';

export default {
    name: 'OnCallView',
    data() {
        return {
            onCallList: [],
            loading: true
        };
    },
    async mounted() {
        try {
            const { formatDate } = useDate();
            const formattedDate = formatDate(new Date());
            const response = await axios.get(`/on-call/?estimated_date_start=${formattedDate}`);
            this.onCallList = response.data.data;
        } catch (error) {
            console.error('Error fetching on-call data:', error);
        } finally {
            this.loading = false;
        }
    },
    methods: {
        formatDisplayDate(dateStr) {
            if (!dateStr) return '';
            const [year, month, day] = dateStr.split('-');
            return `${day}.${month}.${year}`;
        },
        isWeekend(dateStr) {
            if (!dateStr) return false;
            const date = new Date(dateStr);
            const day = date.getDay();
            return day === 0 || day === 6;
        }
    }
};
</script>
